import 'angular:locale/data:hr';
import 'angular:locale/data:de';
import 'angular:locale/data:en-US';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
